import React from 'react';
import {
  useNavigate,
} from 'react-router-dom';

import { useTranslation } from 'react-i18next';

import AppIcon from '../../../shared/ui/AppIcon';

import './StatePage.css';

export function FullPageLoader() {
  const { t } = useTranslation('app');

  return (
    <div className="full-page-loader">
      <span className="state-spinner" />
      <p>{t('state.loading')}</p>
    </div>
  );
}

export default function StatePage({
  standalone = false,
  icon = 'warning',
  titleKey,
  descriptionKey,
  actionKey,
  actionPath,
  onAction,
}) {
  const { t } = useTranslation('app');
  const navigate = useNavigate();

  const handleAction = () => {
    if (typeof onAction === 'function') {
      onAction();
      return;
    }

    if (actionPath) {
      navigate(actionPath, {
        replace: true,
      });
    }
  };

  return (
    <div
      className={[
        'state-page',
        standalone ? 'is-standalone' : '',
      ].join(' ')}
    >
      <span className="state-page-icon">
        <AppIcon
          type={icon}
          size={30}
        />
      </span>

      <h2>{t(titleKey)}</h2>
      <p>{t(descriptionKey)}</p>

      {actionKey && (
        <button
          type="button"
          onClick={handleAction}
        >
          {t(actionKey)}
        </button>
      )}
    </div>
  );
}